import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSonarObjectsPageLayoutsAsyncSlice } from './get';

export const coreSonarObjectsPageLayoutsReducers = combineReducers({
	get: getCoreSonarObjectsPageLayoutsAsyncSlice.asyncReducers
});

export const coreSonarObjectsPageLayoutsWatchers = combineAllWatchers([
	getCoreSonarObjectsPageLayoutsAsyncSlice.asyncWatchers
]);
